/* Dear Noel · Editor de temas: evita que las secciones que se mueven solas (Videos, Reseñas, Bundles, Calculadora de talla, Bonos) se dupliquen
   cada vez que se edita algo. Al recargar una sección, borra la copia que ya se había movido a la ficha del producto. */
(function () {
  var prefixes = ['uv-', 'rv-', 'bn-', 'sc-', 'bo-'];
  document.addEventListener('shopify:section:unload', function (ev) {
    var id = ev && ev.detail && ev.detail.sectionId;
    if (!id) { return; }
    var wrap = document.getElementById('shopify-section-' + id);
    prefixes.forEach(function (p) {
      var el = document.getElementById(p + id);
      if (el && (!wrap || !wrap.contains(el))) { el.remove(); }
    });
  });
})();
